/**
 * Created by Angelika on 01.09.2017.
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import PropTypes from 'prop-types';
import * as strings from '../constants/strings';
import * as ChannelsActions from '../actions/channels';
import * as FavoritesActions from '../actions/favorites';
import ChannelItem from '../components/ChannelItem';
import * as VideoActions from "../actions/video";

class ChannelList extends Component {
    render() {
        const {items, channelsActions, videoActions, favoritesActions} = this.props;
        return (
            <div className="channel-list">
                {items && items.length > 0 ?
                    items.map((item, index) => (
                        <ChannelItem channelsActions={channelsActions}
                                     videoActions={videoActions}
                                     key={index} item={item}
                                     onClick={() => channelsActions.playChannel(item, true)}
                                     favoritesActions={favoritesActions}/>
                    ))
                    : <div>{strings.STR_CHANNEL_LIST_EMPTY}</div>
                }
            </div>
        )
    }
}

ChannelList.propTypes = {
    items: PropTypes.array,
    channelsActions: PropTypes.object.isRequired,
    favoritesActions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
    return {
        channelsActions: bindActionCreators(ChannelsActions, dispatch),
        favoritesActions: bindActionCreators(FavoritesActions, dispatch),
        videoActions: bindActionCreators(VideoActions, dispatch),
    }
};

export default connect(
    null,
    mapDispatchToProps
)(ChannelList);


// WEBPACK FOOTER //
// ./src/containers/ChannelList.js